
    import { Vue, Component, Prop, Watch } from "vue-property-decorator";
    import { v4 as uuid } from "uuid";
  
    import FormInput from "@/components/form/FormInput.vue";
    import Processing from "@/components/common/Processing.vue";
    import FormGroupError from "@/components/form/FormGroupError.vue";
  
    @Component({
      components: {
        FormGroupError,
        FormInput,
        Processing,
      },
    })
    export default class ManagerAddonFormGroup extends Vue {

        @Prop({ type: String, default: "" }) readonly formInputClass!: string;
    @Prop({ type: String, default: undefined }) readonly title?: string;
  
        get labelShown(): boolean {
      const labelComponentUsed = Boolean(this.$scopedSlots.title);
      const titleUsed = Boolean(this.title);
      return labelComponentUsed || titleUsed;
    }
      get inputClasses(): Object {
        return  "focus:border-primary";
      }
  
    }
  